<template>
  <div>
    <div>
      <!-- 播放 -->
      <div :class="[ !mini ? '' : 'terse' , 'player' ]">
        <!-- 进度条 -->
        <div :class=" !mini ? '' : 'terse-line' " v-show="!show_origin_player">
          <div class="progress-box">
            <div class="v-progress">
              <van-slider
                v-model.number="pgNum"
                bar-height="2px"
                active-color="#EB5032"
                @change="moveSlider"
              >
                <div slot="button" class="custom-button"></div>
              </van-slider>
            </div>
          </div>
          <!-- 播放时间 -->
          <div class="play-slider">
            <div :class="[ !mini ? 'time-margin' : '' , 'play-time clearfix' ]">
              <span class="pull-left">{{ curTime }}</span>
              <span class="pull-right">{{ allTime }}</span>
            </div>
          </div>
        </div>
        <!-- 播放器 -->
        <div class="media">
          <audio
            @timeupdate="playIng($event)"
            @playing="startPlay($event)"
            @pause="stopPlay($event)"
            @canplaythrough="readyPlay($event)"
            @waiting="waiting($event)"
            @ratechange="rateChange($event)"
            ref="audio"
            name="media"
            preload="auto" v-if="!show_origin_player">
          </audio>
          <audio
            @timeupdate="playIng($event)"
            @playing="startPlay($event)"
            @pause="stopPlay($event)"
            @canplaythrough="readyPlay($event)"
            @waiting="waiting($event)"
            @ratechange="rateChange($event)"
            ref="audio"
            name="media"
            controls="controls"
            controlsList="nodownload"
            oncontextmenu="return false"
            class="origin-player"
            preload="auto" v-else>
            你的浏览器不支持播放此音频
          </audio>
        </div>
        <!-- 播放按钮 -->
        <div :class="!mini ? 'button-margin' : 'button-scale'">
          <!-- 倍数 -->
          <a v-show="!mini" @click="changeTimes" class="speed">
            {{ speedVal }}X
          </a>
          <!-- :class="{hidden: show_origin_player}" -->
          <a v-show="state === 0" @click="playStart" class="play-button play-start"></a>
          <div v-show="state === 1" class="play-button play-loading">
            <img src="@a/play_v.png" alt="" />
          </div>
          <a v-show="state === 2" @click="playStop" class="play-button play-stop"></a>
          <!-- 知识点 -->
          <img v-if="status==1" src="@a/knowledge.png" class="play_tab" @click="knowledgeHandle()" alt="" />
        </div>
      </div>
    </div>
    <!-- <audio v-if="show_origin_player" controls="controls" preload="preload" class="origin-player" :src="src"></audio> -->
    <!-- <div v-if="show_origin_player" @click="changePlayerType" class="text-center mt20 text-red text-bold">切换播放器</div> -->
  </div>
</template>
<script>
  import { setStorage, getStorage, isMain } from '@/utils/tools'
  export default {
    props: {
      src: {
        type: String,
        default: ""
      },
      volume: {
        type: Number,
        default: 0.8
      },
      mini: {
        type: Boolean,
        default: false
      },
      status:{
        default:0
      }
    },
    data(){
      return {
        ready: false,
        start: false,
        audio: null,
        pgNum: 0,
        state: 0,
        lock: false,
        curTime: "00:00",
        allTime: "00:00",
        speedVal: 1,
        show_origin_player: false,
        hls: null,
        autoplay: false
      }
    },
    created(){
      // if(isMain()) {
      //   this.setPlayerType();
      // }
    },
    mounted(){
      // 元素
      this.audio = this.$refs.audio;
      this.audio.volume = this.volume;

      if(this.src.endsWith('.m3u8')){
        try {
          const Hls = require('hls.js')
          if (Hls.isSupported()) {
            if (!this.hls) {
              this.hls = new Hls();
            }
            this.hls.loadSource(this.src);
            this.hls.attachMedia(this.audio);
            if(this.autoplay){
                let _this = this;
                this.hls.on(Hls.Events.MANIFEST_PARSED,function() {
                    _this.audio.play();
                });
            }
          } else {
              console.warn('HLS is not supported on your browser')
              this.audio.src = this.src;
              if(this.autoplay){
                  let _this = this;
                  this.audio.addEventListener('loadedmetadata',function() {
                      _this.audio.play();
                  });
              }
          }
        } catch (e) {
          console.log(e);
          console.warn('hls.js is required to support m3u8');
          this.audio.src = this.src;
        }
      }else{
          this.audio.src = this.src;
      }
    },
    methods: {
      /*
       *@param:
       *@return:
       *@Description: 知识点点击触发函数
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-20 10:25:25
      */
      knowledgeHandle(){
        this.$emit('knowledgeHandle');
      },
      setPlayerType(){
        let path = this.$route.path;
        let val = getStorage(path, 'playerType');

        if(val == 'true' || val === true) {
          this.show_origin_player = true;
        } else {
          this.show_origin_player = false;
        }
      },
      changePlayerType(){
        this.show_origin_player=!this.show_origin_player;
        let path = this.$route.path;
        let val = this.show_origin_player;
        setStorage(path, 'playerType', val);
      },
      // 切换倍数
      changeTimes(){
        if(this.speedVal >= 2){
          this.speedVal = 1;
          this.setAudioTimes();
          return
        }
        this.speedVal += 0.25;
        this.setAudioTimes();
      },
      // 设置播放器倍数
      setAudioTimes(){
        this.audio.playbackRate = this.speedVal;
      },
      // 当前时间的格式化字符串
      timeTostring(s){
        var MM = Math.floor(s / 60);
        var SS = s % 60;
        if(MM < 10) MM = "0" + MM;
        if(SS < 10) SS = "0" + SS;
        var min = MM + ":" + SS;
        return min.split('.')[0];
      },
      // 手动调用
      playStart(){
        // 开始播放器
        this.audio.play();
      },
      playStop(){
        // 暂停播放
        this.audio.pause();
      },
      // 拖动滑块
      moveSlider(num){
        setTimeout(() => {
          this.lock = false;
          this.audio.currentTime = this.audio.duration * ( num / 100 );
          this.playStart();
        }, 0)
      },
      // 加载中
      waiting(ev){
        this.state = 1;
      },
      // 播放器事件
      playIng(ev){
        // 计算当前时间
        let curTime = ev.srcElement.currentTime;
        this.curTime = this.timeTostring(curTime);
        // 触发自定义事件 playing -- 播放中
        this.$emit('playing', ev, this.curTime, this.allTime);
        // 是否vant slider正在拖拽， 监听属性变化值得大小判断
        if( this.lock ){
          return
        }
        // 计算当前时间与滑块的值
        let allTime = ev.srcElement.duration;
        this.pgNum = Math.floor( (curTime / allTime) * 100 );
      },
      stopPlay(ev){
        this.start = false;

        if(this.ready) {
          this.state = 0;
        }
        // 触发自定义事件 playstop -- 播放暂停
        this.$emit('playstop', ev);
      },
      startPlay(ev){
        this.start = true;

        if(this.ready){
          this.state = 2;
        }
        // 触发自定义事件 playstart -- 播放开始
        this.$emit('playstart', ev);
      },
      readyPlay(ev){
        this.ready = true;

        if(this.start){
          this.state = 2;
        } else {
          this.state = 0;
        }

        this.allTime = this.timeTostring(ev.srcElement.duration);
        // 触发自定义事件 playready -- 播放准备就绪
        this.$emit('playready', ev, this.allTime);
      },
      rateChange(ev){
        this.$emit("ratechange", ev);
      },
    },
    watch: {
      pgNum(newVal, nldVal){
        if(newVal - nldVal > 1){
          this.lock = true;
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../style/remChange.scss";
  .origin-player{
    width: 100%;
  }
  .mt20{
    margin-top: 20px;
  }
  .text-red{
    color: #EB5032;
  }
  .text-bold{
    font-weight: bold;
  }
  // 倍数
  .speed{
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    margin-top: 40px;
    text-align: center;
    width:64px;
    line-height: 44px;
    border: 2px solid #666;
    border-radius: 22px;
    color: #666;
    font-size: 22px;
  }
  // 播放-背景
  .player{
    height: 100%;
    margin: 0 auto;
    margin-top: changeRem(1)+px;
  }
  .player.terse{
    margin-top: 0;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    align-items: center;
  }
  .terse-line{
    flex: 1;
    transform: translateY(8px);
  }
  // 进度条-背景
  .progress-box{
    height: 30px;
    display: flex;
    align-items: center;
  }
  .v-progress{
    width: 100%;
    height: 2px;
  }
  .custom-button{
    background: #333333;
    width: 30px;
    height: 30px;
    border-radius: 15px;
  }
  // 播放按钮
  .play-button{
    display: block;
    background: url(../assets/play3.png) top left no-repeat;
    width: 100px;
    height: 100px;
    line-height:100px;
    text-align: center;
    background-size: cover;
    margin: 0 auto 0;
  }
  .button-margin{
    // margin-top: 38px;
    position: relative;
    padding: 10px 0;
  }
  .button-scale{
    transform: scale(0.5);
    padding: 5.5px;
  }
  .play-loading{
    background-color: rgb(51,51,51);
    border-radius: 50%;
    // background-image: url(../assets/play_b.png);
    // background-position-x: left;
    img{
      width: 80px;
      height: 80px;
      margin: 0 auto;
      vertical-align: middle;
      -webkit-animation: load-img 1s infinite linear;
      animation: load-img 1s infinite linear;
    }
  }
  .play-time{
    span{
      font-size: 20px;
      color: #333;
      margin-top: 6px
    }
  }
  .play-stop{
    background-position-x: right;
    background-size: cover;
  }
  .play-slider .pull-left, .play-slider .pull-right{
    line-height: 1;
    margin-top: 10px;
    margin-bottom: 6px;
  }
  // 加载中动画
  @keyframes load-img {
    0% {
      transform: rotate(0deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }
  .van-slider {
    height: 2px;
    background-color: #ccc;
  }
  .play_tab {
    top: 0;
    width: 64px;
    position: absolute;
    right: 0;
    margin-top: 40px;
  }
  .hidden {
    visibility: hidden;
  }
</style>